import { createActions } from 'redux-actions'

export const INIT_MEMBER_INFO = "INIT_MEMBER_INFO";

export const GET_MEMBER_DETAIL_START = "GET_MEMBER_DETAIL_START";
export const GET_MEMBER_DETAIL_SUCCESS = "GET_MEMBER_DETAIL_SUCCESS";
export const GET_MEMBER_DETAIL_FAIL = "GET_MEMBER_DETAIL_FAIL";

export const SEARCH_MEMBER_START = "SEARCH_MEMBER_START";
export const SEARCH_MEMBER_SUCCESS = "SEARCH_MEMBER_SUCCESS";
export const SEARCH_MEMBER_FAIL = "SEARCH_MEMBER_FAIL";

export const GET_MEMBER_ADDRESS_START = "GET_MEMBER_ADDRESS_START";
export const GET_MEMBER_ADDRESS_SUCCESS = "GET_MEMBER_ADDRESS_SUCCESS";
export const GET_MEMBER_ADDRESS_FAIL = "GET_MEMBER_ADDRESS_FAIL";

export const GET_MEMBER_ADDRESS_DETAIL_START = "GET_MEMBER_ADDRESS_DETAIL_START";
export const GET_MEMBER_ADDRESS_DETAIL_SUCCESS = "GET_MEMBER_ADDRESS_DETAIL_SUCCESS";
export const GET_MEMBER_ADDRESS_DETAIL_FAIL = "GET_MEMBER_ADDRESS_DETAIL_FAIL";

export const CART_GET_LIST_START = "CART_GET_LIST_START";
export const CART_GET_LIST_SUCCESS = "CART_GET_LIST_SUCCESS";
export const CART_GET_LIST_FAIL = "CART_GET_LIST_FAIL";

export const CART_EDIT_START = "CART_EDIT_START";
export const CART_EDIT_SUCCESS = "CART_EDIT_SUCCESS";
export const CART_EDIT_FAIL = "CART_EDIT_FAIL";

export const CART_REMOVE_START = "CART_REMOVE_START";
export const CART_REMOVE_SUCCESS = "CART_REMOVE_SUCCESS";
export const CART_REMOVE_FAIL = "CART_REMOVE_FAIL";

export const CART_MULTIPLE_REMOVE_START = "CART_MULTIPLE_REMOVE_START";
export const CART_MULTIPLE_REMOVE_SUCCESS = "CART_MULTIPLE_REMOVE_SUCCESS";
export const CART_MULTIPLE_REMOVE_FAIL = "CART_MULTIPLE_REMOVE_FAIL";

export const GET_MEMBER_PROFILE_START = "GET_MEMBER_PROFILE_START";
export const GET_MEMBER_PROFILE_SUCCESS = "GET_MEMBER_PROFILE_SUCCESS";
export const GET_MEMBER_PROFILE_FAIL = "GET_MEMBER_PROFILE_FAIL";

export const {

  initMemberInfo,

  getMemberDetailStart,
  getMemberDetailSuccess,
  getMemberDetailFail,

  searchMemberStart,
  searchMemberSuccess,
  searchMemberFail,

  getMemberAddressStart,
  getMemberAddressSuccess,
  getMemberAddressFail,

  getMemberAddressDetailStart,
  getMemberAddressDetailSuccess,
  getMemberAddressDetailFail,

  cartGetListStart,
  cartGetListSuccess,
  cartGetListFail,

  cartEditStart,
  cartEditSuccess,
  cartEditFail,

  cartRemoveStart,
  cartRemoveSuccess,
  cartRemoveFail,

  cartMultipleRemoveStart,
  cartMultipleRemoveSuccess,
  cartMultipleRemoveFail,

  getMemberProfileStart,
  getMemberProfileSuccess,
  getMemberProfileFail,

} = createActions({

  [INIT_MEMBER_INFO]: (req) => ({ req }),

  [GET_MEMBER_DETAIL_START]: (req) => ({ ...req }),
  [GET_MEMBER_DETAIL_SUCCESS]: (res) => ({ res }),
  [GET_MEMBER_DETAIL_FAIL]: (res) => ({ res }),

  [SEARCH_MEMBER_START]: (req) => ({ ...req }),
  [SEARCH_MEMBER_SUCCESS]: (res) => ({ res }),
  [SEARCH_MEMBER_FAIL]: (res) => ({ res }),

  [GET_MEMBER_ADDRESS_START]: (req) => ({ ...req }),
  [GET_MEMBER_ADDRESS_SUCCESS]: (res) => ({ res }),
  [GET_MEMBER_ADDRESS_FAIL]: (res) => ({ res }),

  [GET_MEMBER_ADDRESS_DETAIL_START]: (req) => ({ ...req }),
  [GET_MEMBER_ADDRESS_DETAIL_SUCCESS]: (res) => ({ res }),
  [GET_MEMBER_ADDRESS_DETAIL_FAIL]: (res) => ({ res }),

  [CART_GET_LIST_START]: (req) => ({ ...req }),
  [CART_GET_LIST_SUCCESS]: (res) => ({ res }),
  [CART_GET_LIST_FAIL]: (res) => ({ res }),

  [CART_EDIT_START]: (req) => ({ ...req }),
  [CART_EDIT_SUCCESS]: (res) => ({ res }),
  [CART_EDIT_FAIL]: (res) => ({ res }),

  [CART_REMOVE_START]: (req) => ({ ...req }),
  [CART_REMOVE_SUCCESS]: (res) => ({ res }),
  [CART_REMOVE_FAIL]: (res) => ({ res }),

  [CART_MULTIPLE_REMOVE_START]: (req) => ({ ...req }),
  [CART_MULTIPLE_REMOVE_SUCCESS]: (res) => ({ res }),
  [CART_MULTIPLE_REMOVE_FAIL]: (res) => ({ res }),

  [GET_MEMBER_PROFILE_START]: (req) => ({ ...req }),
  [GET_MEMBER_PROFILE_SUCCESS]: (res) => ({ res }),
  [GET_MEMBER_PROFILE_FAIL]: (res) => ({ res }),

})


